import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * お知らせカテゴリ一覧API
 * @param  {} params={}
 */
export const listCategories = (params = {}) => {
  const defaults = {
    _path: 'IN/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
// TODO:共通処理のマスター取得利用に切り替わったので、後で削除

/**
 * お知らせ一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const defaults = {
    _path: 'IN/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * お知らせ詳細API
 * @param  {} params={}
 */
export const detail = (params = {}) => {
  const defaults = {
    _path: 'IN/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
